export default __webpack_public_path__ + "static/media/our-endless-numbered-days.b4817ea6.jpg";